import { render, staticRenderFns } from "./AdminScenarios.vue?vue&type=template&id=c3ac5562&"
import script from "./AdminScenarios.vue?vue&type=script&lang=js&"
export * from "./AdminScenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports